import { useEffect } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Benefits from "@/components/Benefits";
import Room from "@/components/Room";
import WhyJoin from "@/components/WhyJoin";
import Testimonials from "@/components/Testimonials";
import Urgency from "@/components/Urgency";
import Manifesto from "@/components/Manifesto";
import FinalCTA from "@/components/FinalCTA";
import Footer from "@/components/Footer";
import { rememberReferralCode } from "@/lib/referrals";

const Landing = () => {
  useEffect(() => {
    rememberReferralCode(window.location.search);
  }, []);

  return (
    <main className="relative min-h-screen" data-testid="landing-page">
      <Nav />
      <Hero />
      <Benefits />
      <Room />
      <WhyJoin />
      <Testimonials />
      <Urgency />
      <Manifesto />
      <FinalCTA />
      <Footer />
    </main>
  );
};

export default Landing;
